import { css } from '@emotion/core';
import theme from './theme';

const perfectScrollbar = css`
  /*
  * Container style
  */
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }

  /*
  * Scrollbar rail styles
  */
  .ps__rail-x {
    display: none;
    position: absolute;

    transition: background-color .2s linear, opacity .2s linear;
    -webkit-transition: background-color .2s linear, opacity .2s linear;
    height: 15px;
    /* there must be 'bottom' or 'top' for ps__rail-x */
    bottom: 0px;
    /* please don't change 'position' */
    position: absolute;

    ::after {
      content: "";
      height: 5px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 2px;
      background: ${theme.color.brandLight};
      opacity: 0.5;
    }
  }

  .ps__rail-y {
    display: none;
    position: absolute;

    transition: background-color .2s linear, opacity .2s linear;
    -webkit-transition: background-color .2s linear, opacity .2s linear;
    height: 15px;
    /* there must be 'right' or 'left' for ps__rail-y */
    right: 0;
    /* please don't change 'position' */
    position: absolute;

    ::after {
      content: "";
      width: 5px;
      height: 100%;
      position: absolute;
      right: 2px;
      top: 0;
      background: ${theme.color.brandLight};
      opacity: 0.5;
    }
  }

  .ps--active-x > .ps__rail-x,
  .ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
  }

  /*
  * Scrollbar thumb styles
  */
  .ps__thumb-x {
    background-color: ${theme.color.brand};
    transition: background-color .2s linear, height .2s ease-in-out;
    -webkit-transition: background-color .2s linear, height .2s ease-in-out;
    height: 5px;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 2px;
    /* please don't change 'position' */
    position: absolute;
    z-index: 2;
  }

  .ps__thumb-y {
    background-color: ${theme.color.brand};
    transition: background-color .2s linear, width .2s ease-in-out;
    -webkit-transition: background-color .2s linear, width .2s ease-in-out;
    width: 5px;
    /* there must be 'right' for ps__thumb-y */
    right: 2px;
    /* please don't change 'position' */
    position: absolute;
    z-index: 2;
  }

  /* MS supports */
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
      overflow: auto !important;
    }
}
`;

export default perfectScrollbar;
